<div class="row">
  <div class="wraper" style="width: 100%;">
    <div class="row">
      <div class="overlay" *ngIf="loading">
        <div class="spinner-wrapper">
          <app-spinner>
            <span style="font-size: 3em; color: #27AE61;"><i class="fal fa-atom-alt fa-spin"></i></span>
          </app-spinner>
        </div>
      </div>
      <div class="col-12" *ngIf="requisition">
        <div *ngIf="editRequisitionFlag else requisitionInfo">
          <app-receiving-edit-requisition (updateDone)="reqRequisitionUpdated()" packageDeliveredDate="{{packageDeliveredDate}}"
                                          (updateFailed)="reqRequisitionUpdateFailed($event)" (cancelled)="cancelEditRequisition()">
          </app-receiving-edit-requisition>
        </div>
        <ng-template #requisitionInfo pTemplate="content">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-4">
                  Requisition - {{requisition.Accession}}
                </div>
                <div class="col-3">
                  <span [hidden]="!securityService.hasClaim('Requisition_View_Status')">
                    Status: {{requisition.Status}} <small>as of  {{requisition.StatusDate | date:'short'}} </small>
                    <a (click)="getStatusHistory();" class="iconbutton" title="Show Status History">
                      <i class="fal fa-history"></i>
                    </a>
                  </span>
                </div>
                <div class="col-5">
                  <div class="float-right">
                    <a *hasClaim="'Bill_Edit'" [hidden]="!requisition.Accession"
                       (click)="updateOrder()" class="iconbutton" title="Refresh Order from OrderHub">
                      <i class="fal fa-arrow-circle-down" style="font-size: 18px"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-4">
                  <div class="card">
                    <div class="card-header">
                      Patient
                    </div>
                    <div class="card-body">
                      <div>
                        <label>Name: </label> {{requisition.LastName}}, {{requisition.FirstName}}
                      </div>
                      <div>
                        <label>Birthdate: </label> {{requisition.BirthDate | date:'MM/dd/yyyy'}}
                        <label class="margin-left-15">Gender: </label> {{genderDescription}}
                      </div>
                      <div>
                        <label>Race: </label> {{requisition.Race}}
                        <label class="margin-left-15">Ethnicity: </label> {{requisition.Ethnicity}}
                      </div>
                      <div>
                        <label>MRN: </label> {{requisition.MRN}}
                      </div>
                      <div>
                        <label>Address: </label> {{requisition.Address1}}
                      </div>
                      <div [hidden]="!requisition.Address2">
                        <label>Address 2: </label> {{requisition.Address2}}
                      </div>
                      <div>
                        <label>City/State: </label> {{requisition.City}} {{requisition.State}} {{requisition.Zip}}
                      </div>
                      <div>
                        <label>Email: </label> {{requisition.Email}}
                        <a *hasClaim="'Bill_Edit'"
                           [ngClass]="(disableSampleInfoEdit) ? 'disabled' : ''"
                           (click)="showEmail();" class="iconbutton" title="Edit">
                          <i class="far fa-edit" style="font-size: 18px"></i>
                        </a>
                      </div>
                      <div>
                        <label>Phone: </label> {{requisition.Phone}}
                        <a *hasClaim="'Bill_Edit'"
                           [ngClass]="(disableSampleInfoEdit) ? 'disabled' : ''"
                           (click)="showPhone();" class="iconbutton" title="Edit">
                          <i class="far fa-edit" style="font-size: 18px"></i>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="card margin-top-20">
                    <div class="card-header">
                      ICD-10
                    </div>
                    <div class="card-body">
                      <div class="row" *ngFor="let x of sortRequisitionICD(requisition.RequisitionICD10s)">
                        <div class="col-12 pl-4">
                          <i class="fal fa-check" [hidden]="!x.IsQualified"></i>
                          <label>{{x.IDC10_Formatted}}: </label> {{x.Name}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-4">
                  <div class="card">
                    <div class="card-header">
                      Client
                    </div>
                    <div class="card-body">
                      <div>
                        <label>Client: </label> {{requisition.ClientName}}
                      </div>
                      <div>
                        <label>Facility: </label> {{requisition.FacilityName}}<small> ({{requisition.FacilityCode}})</small>
                      </div>
                      <div>
                        <label>Provider: </label> {{requisition.ProviderName}} <span [hidden]="requisition.ProviderNPI==null"><small>({{requisition.ProviderNPI}})</small></span>
                      </div>
                      <div ng-if="requisition.RequisitionBilling.IsInstitutionalBill">
                        <div>
                          <label>Institutional Bill Settings</label>
                          <a *hasClaim="'Bill_Edit'"
                             [ngClass]="(disableSampleInfoEdit) ? 'disabled' : ''"
                             (click)="showInstBillEdit();" class="iconbutton" title="Edit">
                            <i class="far fa-edit" style="font-size: 18px"></i>
                          </a>
                        </div>
                        <div>
                          &nbsp;&nbsp;<label>Responsible Party: </label> {{clientInstBillSettings.InstBillResponsibleParty}}
                        </div>
                        <div>
                          &nbsp;&nbsp;<label>AMD Carrier: </label>
                          <span [hidden]="!clientInstBillSettings.InstBillProviderCode"> {{clientInstBillSettings.InstBillProviderName}} <small>({{clientInstBillSettings.InstBillProviderCode}})</small></span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card margin-top-20">
                    <div class="card-header">
                      Insurance/Pay Options
                    </div>
                    <div class="card-body">
                      <div class="row" *ngFor="let x of requisition.RequisitionPays">
                        <div class="col-12 pl-4">
                          <label>Provider: </label> {{x.InsProviderName}}
                          <a *hasClaim="'PackageReq_Edit'"
                             [hidden]="x.InsProviderName == 'Facility Financial Responsibility'
                                || x.InsProviderName == 'Patient Financial Responsibility'
                                || x.InsProviderName == 'Prepaid'
                                || x.InsProviderName == 'Express Pay'"
                             (click)="showPaymentEdit(x,'req')" class="iconbutton" title="Edit Insurnace">
                            <i class="far fa-edit" style="font-size: 18px"></i>
                          </a>
                        </div>
                        <div class="col-12 pl-4">
                          &nbsp;&nbsp;<label>Policy: </label> {{x.Policy}} &nbsp;&nbsp;&nbsp;<label>Group: </label> {{x.Group}}
                        </div>
                        <div class="col-12 pl-4">
                          &nbsp;&nbsp;<label>Carrier: </label>
                          <span [hidden]="!x.BillingProviderCode"> {{x.BillingProviderName}} <small>({{x.BillingProviderCode}})</small></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card margin-top-20">
                    <div class="card-header">
                      Billing Log
                      <div class="float-right" *ngIf="canSubmitAppeal">
                        <span *hasClaim="'Bill_Edit'">
                          <a (click)="showAppealEdit()" class="iconbutton" title="Record Claim Submission">
                            <i class="far fa-file-text" style="font-size: 18px"></i>
                          </a>
                        </span>
                      </div>
                    </div>
                    <div class="card-body">
                      <div *ngIf="!requisition.RequisitionBilling.IsVipRequisition && !requisition.RequisitionBilling.IsTestRequisition">
                        <div class="row" *ngFor="let rbc of requisition.RequisitionBilling.RequisitionBillingClaims">
                          <div class="col-12 pl-4">
                            <div class="row" *ngIf="rbc.IsInstitutionalBill">
                              <div class="col-12">
                                Institutional Bill
                              </div>
                            </div>
                            <div class="row" *ngIf="rbc.IsInsuranceBill">
                              <div class="col-12">
                                Insurance Bill
                              </div>
                            </div>
                            <div>
                              <label>CPT: </label> {{rbc.CPT}}
                            </div>
                            <div>
                              <label>Billed Amount: </label> {{rbc.BilledAmount | currency}}
                            </div>
                          </div>
                          <div class="col-12" *ngFor="let rbcl of rbc.RequisitionBillingClaimLogs">
                            <div class="col-12 pl-4">
                              <label>Date: </label> {{rbcl.ActivityDate | date:'MM/dd/yyyy' }}
                              <div class="float-right">
                                <span *hasClaim="'Bill_Edit'">
                                  <a (click)="showClaimLog(rbcl)" *ngIf="!rbcl.UpdatedBy.startsWith('ADM.') && !rbcl.UpdatedBy.startsWith('AMD.')" class="iconbutton" title="Edit Claim Log">
                                    <i class="far fa-edit" style="font-size: 18px"></i>
                                  </a>
                                </span>
                              </div>
                            </div>
                            <div class="col-12 pl-6">
                              <label>Activity: </label> {{rbcl.Activity}}
                              <label>Amount: </label> {{rbcl.Amount | currency}}
                            </div>
                            <div class="col-12 pl-6" *ngIf="rbcl.InsuranceCode">
                              <label>Carrier: </label> {{rbcl.InsuranceName}}  ({{rbcl.InsuranceCode}})
                            </div>
                            <div class="col-12 pl-6" *ngIf="rbcl.ActivityCode == 'AP'">
                              <label>Notes: </label> {{rbcl.Description }}
                            </div>
                            <div class="col-12 pl-6" *ngIf="rbcl.ActivityCode == 'AP'">
                              <label>By: </label> {{rbcl.UpdatedBy}}
                            </div>
                            <div class="col-12 pl-6" *ngIf="rbcl.ReasonCode">
                              <label>Reason: </label> {{rbcl.ReasonDescription}}  ({{rbcl.ReasonCode}})
                            </div>
                            <div class="col-12 pl-6" *ngIf="rbcl.ActivityCode !== 'CR'">
                              <label>Balance Due: </label> {{rbcl.TotalBalance | currency }}
                              <label> Ins: </label> {{rbcl.InsuranceBalance | currency}}
                              <label> Pat: </label> {{rbcl.PatientBalance | currency}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-4">
                  <div class="card">
                    <div class="card-header">
                      Order Details
                    </div>
                    <div class="card-body">
                      <div>
                        <label>Ordered: </label> {{requisition.LabPanelName}}<small> ({{requisition.OrderCode}})</small>
                        <a (click)="getRequisitionDoc()" class="iconbutton" title="Get Requisition PDF">
                          <i class="far fa-print"></i>
                        </a>
                      </div>
                      <div>
                        <label>Specimen Type: </label> {{requisition.SpecimenTypeName}}
                      </div>
                      <div>
                        <label>Collected: </label> {{requisition.DateOfService | date:'MM/dd/yyyy hh:mm a'}}<small> by {{requisition.SpecimenCollectedBy}}</small>
                      </div>
                      <div>
                        <label>Received: </label> {{requisition.DateReceived | date:'MM/dd/yyyy hh:mm a'}}<small></small>
                      </div>
                      <div>
                        <label>Completed: </label> {{requisition.DateCompleted | date:'MM/dd/yyyy hh:mm a'}}<small></small>
                        <a (click)="getResultReport()" class="iconbutton" title="Get Result PDF">
                          <i class="far fa-print"></i>
                        </a>
                      </div>
                      <div>
                        <label>Status: </label> {{requisition.Status}}
                      </div>
                      <div class="row" [hidden]="!requisition.IsRejected">
                        <div class="col-12 text-danger">
                          <h4>REJECTED</h4>
                        </div>
                      </div>
                      <div class="row" *ngFor="let x of requisition.RequisitionRejections">
                        <div class="col-12">
                          <label class="text-danger margin-bottom-5"
                                 [ngClass]="{'strikethrough': x.Unrejected}">{{x.RejectionTypeName}}</label>
                          <a *hasClaim="'PackageReq_Edit'" [hidden]="x.Unrejected || x.RejectionType == 3"
                             (click)="showUnreject(x,'req')" class="ml-4 iconbutton" title="Un Reject">
                            <i class="far fa-thumbs-up"></i>
                          </a>
                          <span *hasClaim="'PackageReq_Edit'" [hidden]="x.Unrejected || x.RejectionType != 3"
                                title="QNS rejections cannot be unrejected" class="ml-4 disabled" disabled="disabled">
                            <i class="far fa-thumbs-up"></i>
                          </span>
                        </div>
                        <div class="col-12">
                          <small class="float-right">
                            Rejected on {{x.CreatedDate | date:'short'}} by {{x.CreatedBy}}
                            <span [hidden]="!x.Description" title="{{x.Description}}">
                              <i class="far fa-comment-dots"></i>
                            </span>
                          </small>
                        </div>
                        <div class="col-12 float-right" [hidden]="!x.Unrejected">
                          <small class="float-right">
                            Unrejected on {{x.UnrejectedDate | date:'short'}} by
                            {{x.UnrejectedBy}}
                            <span [hidden]="!x.UnrejectDescription" title="{{x.UnrejectDescription}}">
                              <i class="far fa-comment-dots"></i>
                            </span>
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card margin-top-20">
                    <div class="card-header">
                      Billing
                      <div class="float-right">
                        <span *hasClaim="'Bill_Edit'">
                          <a *ngIf="showBillOptionButton "
                             (click)="showBillingEdit()" class="iconbutton" title="Edit Billing Options">
                            <i class="far fa-edit" style="font-size: 18px"></i>
                          </a>
                        </span>
                        <span *hasClaim="'Bill_Edit'">
                          <a *ngIf="showExpressPayButton"
                             (click)="showExpressPayEdit()" class="iconbutton" title="Enter Express Pay Details">
                            <i class="far fa-credit-card" style="font-size: 18px"></i>
                          </a>
                        </span>
                        <span *hasClaim="'Bill_Edit'">
                          <a *ngIf="showSendToADMButton"
                             (click)="sendRequisitionToBilling()" class="iconbutton" title="Send to AdvancedMD"
                             [ngClass]="(!enableSendToADMButton) ? 'disabled' : ''">
                            <i class="fal fa-arrow-from-bottom" style="font-size: 18px"></i>
                          </a>
                        </span>
                      </div>
                    </div>
                    <div class="card-body">
                      <div>
                        <div class="row" *ngIf="sentToADMErrors.length > 0">
                          <div class="col-12">
                            <ul>
                              <li *ngFor="let item of sentToADMErrors" class="text-danger">{{ item }}</li>
                            </ul>
                          </div>
                        </div>
                        <div class="row" *ngIf="requisition.RequisitionBilling.IsInstitutionalBill">
                          <div class="col-12">
                            Institutional Bill
                          </div>
                        </div>
                        <div class="row" *ngIf="!requisition.RequisitionBilling.IsInstitutionalBill && isInsuranceBill">
                          <div class="col-12">
                            Insurance Bill
                          </div>
                          <div class="col-12" *ngIf="requisition.RequisitionBilling.RequisitionBillingClaims.length > 0 && requisition.RequisitionBilling.RequisitionBillingClaims[0].InsuranceCode">
                            {{requisition.RequisitionBilling.RequisitionBillingClaims[0].InsuranceName}} ({{requisition.RequisitionBilling.RequisitionBillingClaims[0].InsuranceCode}})
                          </div>
                        </div>
                        <div class="row" *ngIf="requisition.RequisitionBilling.IsVipRequisition">
                          <div class="col-12 text-danger">
                            VIP Requisition - not billable
                          </div>
                        </div>
                        <div class="row" *ngIf="requisition.RequisitionBilling.IsTestRequisition">
                          <div class="col-12 text-danger">
                            TEST Requisition - not billable
                          </div>
                        </div>
                        <div class="row" *ngIf="!requisition.RequisitionBilling.IsInstitutionalBill && isInsuranceBill">
                          <div class="col-12">
                            <label>PreAuth Code: </label> {{requisition.RequisitionBilling.PreAuthCode}}
                            <a *hasClaim="'Bill_Edit'"
                               [ngClass]="(disableSampleInfoEdit) ? 'disabled' : ''"
                               (click)="showPreAuth();" class="iconbutton" title="Edit">
                              <i class="far fa-edit" style="font-size: 18px"></i>
                            </a>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-12">
                            <label>Status: </label> {{requisition.RequisitionBilling.Status}} <small>at {{requisition.RequisitionBilling.StatusDate | date:'MM/dd/yyyy hh:mm a'}}</small>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-7">
                            <label>Billed: </label>
                            <span class="float-right">
                              {{requisition.RequisitionBilling.BilledAmount | currency}}
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-7">
                            <label>Total Paid: </label>
                            <span class="float-right">
                              {{requisition.RequisitionBilling.TotalPayment | currency}}
                            </span>
                            <br />
                            <label>&nbsp;Insurance Paid: </label>
                            <span class="float-right">
                              {{requisition.RequisitionBilling.InsurancePayment | currency}}
                            </span>
                            <br />
                            <label>&nbsp;Patient Paid: </label>
                            <span class="float-right">
                              {{requisition.RequisitionBilling.PatientPayment | currency}}
                            </span>
                            <br />
                            <label>&nbsp;Institution Paid: </label>
                            <span class="float-right">
                              {{requisition.RequisitionBilling.InstitutionalPayment | currency}}
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-7">
                            <label>Balance: </label>
                            <span class="float-right">
                              {{requisition.RequisitionBilling.TotalBalance | currency}}
                            </span>
                            <br />
                            <label>&nbsp;Insurance Balance: </label>
                            <span class="float-right">
                              {{requisition.RequisitionBilling.InsuranceBalance | currency}}
                            </span>
                            <br />
                            <label>&nbsp;Patient Balance: </label>
                            <span class="float-right">
                              {{requisition.RequisitionBilling.PatientBalance | currency}}
                            </span>
                            <br />
                            <label>&nbsp;Institution Balance: </label>
                            <span class="float-right">
                              {{requisition.RequisitionBilling.InstitutionalBalance | currency}}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-4">
                </div>
                <div class="col-4">
                </div>
                <div class="col-4">
                  <div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
      <p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>
    </div>
  </div>
</div>
<p-toast></p-toast>


<p-dialog [(visible)]="showStatusHistory" [modal]="true">
  <ng-template #header>
    Status History
  </ng-template>
  <div>
    <div *ngFor="let dt of requisitionStatusHistoryList">
      <label>{{dt.Status}}: </label> on {{dt.StatusDate | date:'short'}} by  {{dt.StatusBy}}
    </div>
  </div>
  <ng-template #footer>
    <button (click)="showStatusHistory = false;" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-times" style="font-size: 18px"></i> Close
    </button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="showPaymentDialog" header="Insurance Payment" modal="true" [style]="{width: '90%'}" [closable]="false"
          [closeOnEscape]="false">
  <div class="row">
    <div class="col-12">
      <form [formGroup]="payEditForm">
        <div class="card">
          <div class="card-header">
            OrderHub Insurance
            <div class="float-right">
              <a (click)="savePayment()" class="iconbutton" title="Save"
                 [ngClass]="(payEditForm.invalid || !payEditForm.dirty) ? 'disabled' : ''">
                <i class="fa fa-save" style="font-size: 18px"></i>
              </a>
              <a (click)="cancelPayment()" class="iconbutton" title="Cancel">
                <i class="fa fa-times" style="font-size: 18px"></i>
              </a>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="inputlabel col-4"><label>Provider: </label></div>
              <div class="inputstyle col-8">
                <input formControlName="provider" id="provider" type="text" class="inputstyle" pInputText [value]="pay.Provider" />
                <div *ngIf="payEditForm.controls['provider'].errors?.required" class="valdiation-message-small">
                  * Required
                </div>
              </div>
            </div>
            <div class="row">
              <div class="inputlabel col-4"><label>Policy: </label></div>
              <div class="inputstyle col-8">
                <input formControlName="policy" id="policy" type="text" class="inputstyle" pInputText [value]="pay.Policy" />
                <div *ngIf="payEditForm.controls['policy'].errors?.required" class="valdiation-message-small">
                  * Required
                </div>
              </div>
            </div>
            <div class="row">
              <div class="inputlabel col-4"><label>Group: </label></div>
              <div class="inputstyle col-8">
                <input formControlName="group" id="group" type="text" class="inputstyle" pInputText [value]="pay.Group" />
                <div *ngIf="payEditForm.controls['group'].errors?.required" class="valdiation-message-small">
                  * Required
                </div>
              </div>
            </div>
            <div class="row">
              <div class="inputlabel col-4"><label>Carrier Code: </label></div>
              <div class="inputstyle col-8">{{pay.BillingProviderCode}}</div>
            </div>
            <div class="row">
              <div class="inputlabel col-4"><label>Carrier Name: </label></div>
              <div class="inputstyle col-8">{{pay.BillingProviderName}}</div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          Lookup Carrier
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              Search:
            </div>
            <div class="col-8">
              <input pInputText id="carrierSearchX" (keyup.enter)="loadCarriers()" [(ngModel)]="carrierSearch" type="text" class="inputstyle" value="name..." [style]="{width: '60% !important;'}" />
            </div>
            <div class="col-2">
              <a (click)="loadCarriers()" class="iconbutton" title="Search"><i class="fa fa-search" style="font-size: 18px"></i></a>
            </div>
          </div>
          <div class="row">
            <p-table #carrierlist [value]="carriers" [paginator]="true"
                     [rows]="9" [totalRecords]="carrierCount" [loading]="loading">
              <ng-template pTemplate="header">
                <tr>
                  <th width="80%">Name</th>
                  <th width="20%">Code</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-carrier>
                <tr>
                  <td>
                    <a (click)="setCarrier(carrier)" class="iconbutton" title="carrier.Name">{{carrier.Name}}</a>
                  </td>
                  <td>{{carrier.Code}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<p-dialog *ngIf="showExpressPayDialog" [(visible)]="showExpressPayDialog" header="Prepaid Details" modal="true" [style]="{width: '90%'}" [closable]="false"
          [closeOnEscape]="false">
  <form [formGroup]="expressPayEditForm">
    <div class="card">
      <div class="card-header">
        Enter Express Pay Details for {{requisition.LastName}}, {{requisition.FirstName}}
        <div class="float-right">
          <a (click)="saveExpressPay()" class="iconbutton" title="Save"
             [ngClass]="(expressPayEditForm.invalid || !expressPayEditForm.dirty) ? 'disabled' : ''">
            <i class="fa fa-save" style="font-size: 18px"></i>
          </a>
          <a (click)="cancelExpressPay()" class="iconbutton" title="Cancel">
            <i class="fa fa-times" style="font-size: 18px"></i>
          </a>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="inputlabel col-4"><label>New Email </label></div>
          <div class="inputstyle col-8">
            <input formControlName="amount" id="amount" type="text" class="inputstyle" pInputNumber mode="currency" currency="USD" locale="en-US" />
            <div *ngIf="expressPayEditForm.controls['amount'].errors?.required" class="valdiation-message-small">
              * Required
            </div>
          </div>
        </div>
        <div class="row">
          <div class="inputlabel col-4"><label>Credit Card Transaction </label></div>
          <div class="inputstyle col-8">
            <input formControlName="transactionCode" id="transactionCode" type="text" class="inputstyle" pInputText />
            <div *ngIf="expressPayEditForm.controls['transactionCode'].errors?.required" class="valdiation-message-small">
              * Required
            </div>
          </div>
        </div>
        <div class="row">
          <div class="inputlabel col-4"><label>Credit Card Transaction </label></div>
          <div class="inputstyle col-8">
            <input formControlName="paidDate" id="paidDate" type="datetime-local" class="inputstyle" />
            <div *ngIf="expressPayEditForm.controls['paidDate'].errors?.required" class="valdiation-message-small">
              * Required
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>


<p-dialog *ngIf="showEmailDialog" [(visible)]="showEmailDialog" header="Update Patient" modal="true" [style]="{width: '50%'}" [closable]="false"
          [closeOnEscape]="false">
  <form [formGroup]="emailEditForm">
    <div class="card">
      <div class="card-header">
        Enter New Email Address
        <div class="float-right">
          <a (click)="saveEmail()" class="iconbutton" title="Save"
             [ngClass]="(emailEditForm.invalid || !emailEditForm.dirty) ? 'disabled' : ''">
            <i class="fa fa-save" style="font-size: 18px"></i>
          </a>
          <a (click)="cancelEmail()" class="iconbutton" title="Cancel">
            <i class="fa fa-times" style="font-size: 18px"></i>
          </a>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="inputlabel col-4"><label>Current Email</label></div>
          <div class="inputstyle col-8">{{this.currentEmail}}</div>
        </div>
        <div class="row">
          <div class="inputlabel col-4"><label>New Email</label></div>
          <div class="inputstyle col-8">
            <input formControlName="email" id="email" type="text" class="inputstyle" pInputText [value]="requisition.Email" />
            <div *ngIf="emailEditForm.controls['email'].errors?.required" class="valdiation-message-small">
              * Required
            </div>
            <div *ngIf="emailEditForm.controls['email'].errors?.nowhitespace" class="valdiation-message-small">
              * Cannot contain spaces
            </div>
            <div *ngIf="emailEditForm.controls['email'].errors?.pattern" class="valdiation-message-small">
              * Invalid format
            </div>

          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>


<p-dialog *ngIf="showPhoneDialog" [(visible)]="showPhoneDialog" header="Update Patient" modal="true" [style]="{width: '50%'}" [closable]="false"
          [closeOnEscape]="false">
  <form [formGroup]="phoneEditForm">
    <div class="card">
      <div class="card-header">
        Enter New Phone Number
        <div class="float-right">
          <a (click)="savePhone()" class="iconbutton" title="Save"
             [ngClass]="(phoneEditForm.invalid || !phoneEditForm.dirty) ? 'disabled' : ''">
            <i class="fa fa-save" style="font-size: 18px"></i>
          </a>
          <a (click)="cancelPhone()" class="iconbutton" title="Cancel">
            <i class="fa fa-times" style="font-size: 18px"></i>
          </a>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="inputlabel col-4"><label>Current Phone</label></div>
          <div class="inputstyle col-8">{{this.currentPhone}}</div>
        </div>
        <div class="row">
          <div class="inputlabel col-4"><label>New Phone</label></div>
          <div class="inputstyle col-8">
            <p-inputMask placeholder="(999) 999-9999" mask="(999) 999-9999" formControlName="phone" id="phone"
                         type="text" class="inputstyle"></p-inputMask>
            <div *ngIf="phoneEditForm.controls['phone'].errors?.required" class="valdiation-message-small">
              * Required
            </div>
            <div *ngIf="phoneEditForm.controls['phone'].errors" class="valdiation-message-small">
              * Invalid
            </div>

          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog *ngIf="showPreAuthDialog" [(visible)]="showPreAuthDialog" header="PreAuthorization Code" modal="true" [style]="{width: '50%'}" [closable]="false"
          [closeOnEscape]="false">
  <form [formGroup]="preAuthEditForm">
    <div class="card">
      <div class="card-header">
        Enter Pre Auth Code
        <div class="float-right">
          <a (click)="savePreAuth()" class="iconbutton" title="Save"
             [ngClass]="(preAuthEditForm.invalid || !preAuthEditForm.dirty) ? 'disabled' : ''">
            <i class="fa fa-save" style="font-size: 18px"></i>
          </a>
          <a (click)="cancelPreAuth()" class="iconbutton" title="Cancel">
            <i class="fa fa-times" style="font-size: 18px"></i>
          </a>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="inputlabel col-4"><label>Auth Code</label></div>
          <div class="inputstyle col-8">
            <input formControlName="preAuthCode" id="preAuthCode" type="text" class="inputstyle" pInputText />
            <div *ngIf="preAuthEditForm.controls['preAuthCode'].errors?.required" class="valdiation-message-small">
              * Required
            </div>
            <div *ngIf="preAuthEditForm.controls['preAuthCode'].errors" class="valdiation-message-small">
              * Invalid
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>


<p-dialog *ngIf="showAppealDialog" [(visible)]="showAppealDialog" header="Insurance Claim Submission" modal="true" [style]="{width: '60%'}" [closable]="false"
          [closeOnEscape]="false">
  <form [formGroup]="appealEditForm">
    <div class="card">
      <div class="card-header">
        Record Submission
        <div class="float-right">
          <a (click)="saveAppeal()" class="iconbutton" title="Save"
             [ngClass]="(appealEditForm.invalid || !appealEditForm.dirty) ? 'disabled' : ''">
            <i class="fa fa-save" style="font-size: 18px"></i>
          </a>
          <a (click)="cancelAppealEdit()" class="iconbutton" title="Cancel">
            <i class="fa fa-times" style="font-size: 18px"></i>
          </a>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="inputlabel col-4"><label>Submission Type </label></div>
          <div class="col-8">
            <div class="flex flex-column gap-3">
              <div class="flex align-items-center">
                <p-radioButton formControlName="submissionType"
                               value="AP"
                               inputId="submitTypeA">
                </p-radioButton>
                <label for="submitTypeA" class="ml-2">Appeal</label>
              </div>

              <div class="flex align-items-center">
                <p-radioButton formControlName="submissionType"
                               value="MR"
                               inputId="submitTypeM">
                </p-radioButton>
                <label for="submitTypeM" class="ml-2">Medical Records</label>
              </div>
            </div>

          </div>
        </div>
        <div class="row">
          <div class="inputlabel col-4"><label>Date </label></div>
          <div class="col-8">
            <p-datepicker formControlName="activityDate"
                          id="activityDateId"
                          [showIcon]="true"
                          dataType]="string"
                          [showOnFocus]="false"
                          [minDate]="minAppealDate"
                          [maxDate]="maxDateValue"
                          appendTo="body"></p-datepicker>
            <div *ngIf="appealEditForm.controls['activityDate'].errors?.required" class="valdiation-message-small">
              * Required
            </div>
          </div>
        </div>
        <div class="row">
          <div class="inputlabel col-4"><label>Notes </label></div>
          <div class="inputstyle col-8">
            <input formControlName="description" id="description" type="text" class="inputstyle" pInputText [value]="" />
            <div *ngIf="appealEditForm.controls['description'].errors?.required" class="valdiation-message-small">
              * Required
            </div>
          </div>
        </div>
        <div class="row">
          <div class="inputlabel col-4"><label>Insurance Provider</label></div>
          <div class="inputstyle col-8">
            <input formControlName="insuranceName" id="insuranceName" type="text" class="inputstyle" pInputText [value]="" />
            <div *ngIf="appealEditForm.controls['insuranceName'].errors?.required" class="valdiation-message-small">
              * Required
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>


<p-dialog *ngIf="showBillingDialog" [(visible)]="showBillingDialog" header="Billing Options" modal="true" [style]="{width: '90%'}" [closable]="false"
          [closeOnEscape]="false">
  <form [formGroup]="billEditForm">
    <div class="card">
      <div class="card-header">
        Billing Options
        <div class="float-right">
          <a (click)="saveBilling()" class="iconbutton" title="Save"
             [ngClass]="(billEditForm.invalid || !billEditForm.dirty) ? 'disabled' : ''">
            <i class="fa fa-save" style="font-size: 18px"></i>
          </a>
          <a (click)="cancelBilling()" class="iconbutton" title="Cancel">
            <i class="fa fa-times" style="font-size: 18px"></i>
          </a>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <label for="isVipRequisition" style="font-size: 18px">VIP Requisition?&nbsp;&nbsp;</label>
          <input formControlName="isVipRequisition" id="isVipRequisition" type="checkbox">
        </div>
        <div class="row">
          <label for="isTestRequisition" style="font-size: 18px">Test Requisition?&nbsp;&nbsp;</label>
          <input formControlName="isTestRequisition" id="isTestRequisition" type="checkbox">
        </div>

        <div class="row">
          <label for="isBillingHold" style="font-size: 18px">Place on Billing Hold?&nbsp;&nbsp;</label>
          <input formControlName="isBillingHold" id="isBillingHold" type="checkbox" size="30">
        </div>
      </div>
    </div>
  </form>

  <p-table #noteTable [value]="notes"
           dataKey="Id"
           editMode="row">
    [(editingRowKeys)]="editingRowKeys" >
    <ng-template pTemplate="caption">
      <div class="table-header">
        <div class="row">
          <div class="col-4">
            Billling Notes
          </div>
          <div class="col-3">
          </div>
          <div class="col-5">
            <div class="float-right">
              <a *ngIf="!editingRow" (click)="onInsertRowClick()" class="iconbutton" title="Add Note">
                <i class="fa fa-plus" style="font-size: 18px; color: white"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="NoteDate">
          Date <p-sortIcon field="NoteDate"></p-sortIcon>
        </th>
        <th pSortableColumn="Note">
          Note <p-sortIcon field="Note"></p-sortIcon>
        </th>
        <th style="width:8rem"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body"
                 let-note
                 let-editing="editing"
                 let-ri="rowIndex">
      <tr [pEditableRow]="note">
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <!-- Use DatePicker for editing -->
              <p-datepicker [(ngModel)]="note.NoteDate" appendTo="body" dateFormat="mm/dd/yy" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ note.NoteDate | date: 'MM/dd/yyyy' }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text"
                     [(ngModel)]="note.Note" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ note.Note }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="text-align:center">
          <a *ngIf="!editingRow" (click)="onRowEditInit(note, ri)" pInitEditableRow class="iconbutton" title="Edit">
            <i class="fa fa-pencil" style="font-size: 18px"></i>
          </a>

          <a *ngIf="!editingRow" (click)="onDeleteRowClick(note, ri)" class="iconbutton" title="Delete">
            <i class="fa fa-eraser" style="font-size: 18px"></i>
          </a>

          <a *ngIf="editing" (click)="onRowEditSave(note, ri)" pSaveEditableRow class="iconbutton" title="Save">
            <i class="fa fa-save" style="font-size: 18px"></i>
          </a>

          <a *ngIf="editing" (click)="onRowEditCancel(note, ri)" pCancelEditableRow class="iconbutton" title="Cancel">
            <i class="fa fa-times" style="font-size: 18px"></i>
          </a>
        </td>
      </tr>
    </ng-template>
  </p-table>

</p-dialog>


<p-dialog *ngIf="showInstBillDialog" [(visible)]="showInstBillDialog" header="Institutional BIlling Settings" modal="true" [style]="{width: '90%'}" [closable]="false"
          [closeOnEscape]="false">
  <div class="row">
    <div class="col-12">
      <form [formGroup]="instBillForm">
        <div class="card">
          <div class="card-header">
            Client Settings
            <div class="float-right">
              <a (click)="saveInstBill()" class="iconbutton" title="Save"
                 [ngClass]="(instBillForm.invalid || !instBillForm.dirty) ? 'disabled' : ''">
                <i class="fa fa-save" style="font-size: 18px"></i>
              </a>
              <a (click)="cancelInstBill()" class="iconbutton" title="Cancel">
                <i class="fa fa-times" style="font-size: 18px"></i>
              </a>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="inputlabel col-4"><label>Client: </label></div>
              <div class="inputstyle col-8">{{requisition.ClientName}}</div>
            </div>
            <div class="row">
              <div class="inputlabel col-4"><label>Responsible Party: </label></div>
              <div class="inputstyle col-8">
                <input formControlName="respParty" id="respParty" type="text" class="inputstyle" pInputText [value]="clientInstBillSettings.InstBillResponsibleParty" />
                <div *ngIf="instBillForm.controls['respParty'].errors?.required" class="valdiation-message-small">
                  * Required
                </div>
              </div>
            </div>
            <div class="row">
              <div class="inputlabel col-4"><label>AMD Carrier Code: </label></div>
              <div class="inputstyle col-8">{{clientInstBillSettings.InstBillProviderCode}}</div>
              <div *ngIf="instBillForm.controls['amdCode'].errors?.required" class="valdiation-message-small">
                * Required
              </div>
            </div>
            <div class="row">
              <div class="inputlabel col-4"><label>AMD Carrier Name: </label></div>
              <div class="inputstyle col-8">{{clientInstBillSettings.InstBillProviderName}}</div>
              <div *ngIf="instBillForm.controls['amdName'].errors?.required" class="valdiation-message-small">
                * Required
              </div>
            </div>

          </div>
        </div>
      </form>
    </div>
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          Lookup Carrier
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-2">
              Search:
            </div>
            <div class="col-8">
              <input pInputText id="carrierSearchX" (keyup.enter)="loadCarriers()" [(ngModel)]="carrierSearch" type="text" class="inputstyle" value="name..." [style]="{width: '60% !important;'}" />
            </div>
            <div class="col-2">
              <a (click)="loadCarriers()" class="iconbutton" title="Search"><i class="fa fa-search" style="font-size: 18px"></i></a>
            </div>
          </div>
          <div class="row">
            <p-table #carrierlist [value]="carriers" [paginator]="true"
                     [rows]="9" [totalRecords]="carrierCount" [loading]="loading">
              <ng-template pTemplate="header">
                <tr>
                  <th width="80%">Name</th>
                  <th width="20%">Code</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-carrier>
                <tr>
                  <td>
                    <a (click)="setClientCarrier(carrier)" class="iconbutton" title="carrier.Name">{{carrier.Name}}</a>
                  </td>
                  <td>{{carrier.Code}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
